import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import CategoryItem from 'pages/CategoriesPage/CategoryItem'
import { AuthContext } from 'AuthProvider';

import { getCategoriesList } from 'backend/Category';

const CategoriesPage = () => {
  const  [categories, setCategories] = useState([]);
  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);
  
  useEffect(() => {
    if (categories.length === 0) {
      getCategoriesList()
      .then((result) => {
        setCategories(result);
      })
      .catch((error) => {
        console.log('error', error);
        setCategories([]);
      });
    }
  }, [categories.length]);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="categories" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Категории</li>
              </ul>
            </div>
            <div className="page-content">
              <div className="row">
							  <div className="col-xs-12">
                  <div className="row">
								  	<div className="col-xs-12">
										  <table id="simple-table" className="table  table-bordered table-hover">
											  <thead>
                          <tr>
                            <th>#</th>
                            <th>Алиас</th>
                            <th>EN</th>
                            <th>RU</th>
                            <th>UK</th>
                            <th>IT</th>
                            <th>PL</th>
                            <th>ES</th>
                            <th>PT</th>
                            <th></th>
                          </tr>
											  </thead>

											  <tbody>
                          {categories.map((element, index) => <CategoryItem category={element} key={index} index={index} />)}
                        </tbody>
										  </table>
									  </div>
								  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesPage;
